unit UAbwModel;

interface

uses
  Js;

type
  TAbwModel = class
  private
    FFarbe: Integer;
    FBezeichnung: string;
    FKennzeichen: string;
    FId: Integer;
    procedure SetBezeichnung(const Value: string);
    procedure SetFarbe(const Value: Integer);
    procedure SetId(const Value: Integer);
    procedure SetKennzeichen(const Value: string);
  public
    constructor Create; overload;
    constructor Create(json: string); overload;
    procedure ClearValues;
    procedure SetValues(json: string); overload;
    procedure SetValues(obj: TJsObject); overload;
    property Id: Integer read FId write SetId;
    property Kennzeichen: string read FKennzeichen write SetKennzeichen;
    property Bezeichnung: string read FBezeichnung write SetBezeichnung;
    property Farbe: Integer read FFarbe write SetFarbe;
  end;

implementation

uses
  System.SysUtils;

{ TAbwModel }

procedure TAbwModel.ClearValues;
begin
  Self.Id:=0;
  Self.Kennzeichen:='';
  Self.Bezeichnung:='';
  Self.Farbe:=$FFFFFF;
end;

constructor TAbwModel.Create;
begin
  Self.ClearValues;
end;

constructor TAbwModel.Create(json: string);
begin
  Self.SetValues(json);
end;

procedure TAbwModel.SetBezeichnung(const Value: string);
begin
  FBezeichnung := Value;
end;

procedure TAbwModel.SetFarbe(const Value: Integer);
begin
  FFarbe := Value;
end;

procedure TAbwModel.SetId(const Value: Integer);
begin
  FId := Value;
end;

procedure TAbwModel.SetKennzeichen(const Value: string);
begin
  FKennzeichen := Value;
end;

procedure TAbwModel.SetValues(obj: TJsObject);
begin
  Self.ClearValues;
  if obj['Id']<>nil then
    Self.Id:=StrToInt(string(obj['Id']));
  if obj['Kennzeichen']<>nil then
    Self.Kennzeichen:=string(obj['Kennzeichen']);
  if obj['Bezeichnung']<>nil then
    Self.Bezeichnung:=string(obj['Bezeichnung']);
  if obj['Farbe']<>nil then
    Self.Farbe:=StrToInt(string(obj['Farbe']));
end;

procedure TAbwModel.SetValues(json: string);
var obj: TJsObject;
begin
  obj:=TJsJson.parseObject(json);
  Self.SetValues(obj);
end;

end.
